
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as ggenVilZoeVAMYckEqylXLR7CC4NuSr59U0gqeZqSzjIMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexl2VMoIT6_b1hxatz7DUISdBx5VUbjPwPf_bK1j9OaPQMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchdj7_oSK8moipDG5xPaFYkLVh_ysS7PFS3Dd3_hYO7nAMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexCIdiR4peI196m_45rIB3ldNyQmHlDqx5igvmh2aBx6QqsMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93NHYGbaojMe6juF_LNewkZFML4RWbnh2I4dRynrdP8R0Meta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index5ZkyH81W1TI0WRz__45BAJw_4536rVtZ1Yr3y4nJ_45qHe818Meta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_939A8QC0_IOwQSsT6IAZFPXIPjhGFQ0l_CJ8OCVMAumDEMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexoZ_457YBB2giHcUhRtPGDRGW0hM2oxc8XdZwF8DTHxLsMMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93H8AKb_457fPnVRMNWkbZmlXIJY4skTZniQyAuh3KMjUyAMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexd76ogENzyhNdS45c4HqGEwBG3kOKnDdLsc1ZFkme_45vUMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexrlGXyCMtZoUjMIyvySe_z01EQhZ9krslRI9fn81k8rEMeta } from "/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index5ZkyH81W1TI0WRz__45BAJw_4536rVtZ1Yr3y4nJ_45qHe818Meta || {},
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexoZ_457YBB2giHcUhRtPGDRGW0hM2oxc8XdZwF8DTHxLsMMeta || {},
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexd76ogENzyhNdS45c4HqGEwBG3kOKnDdLsc1ZFkme_45vUMeta || {},
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexrlGXyCMtZoUjMIyvySe_z01EQhZ9krslRI9fn81k8rEMeta || {},
    component: () => import("/codebuild/output/src2919709609/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]